import { useState as t, useEffect as r } from "react";
import { onlineManager as e } from "@tanstack/react-query";
const c = () => {
  const [s, n] = t(e.isOnline());
  return r(() => e.subscribe(n), []), { isOnline: s };
};
export {
  c as u
};
